window._ = require('lodash');


try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) {}


window.axios = require('axios');
import delayAdapterEnhancer from 'axios-delay';
window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': Laravel.csrfToken,
    'X-Requested-With': 'XMLHttpRequest',
    'Authorization': 'Bearer ' + Laravel.apiToken,
};

window.axios = axios.create({
    adapter: delayAdapterEnhancer(window.axios.defaults.adapter)
  });

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import helper from './helper.js';